import type { IconData } from '@stacksjs/iconify-core'

export const alarmClockF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10.962 2.05a5 5 0 1 1 7.668 6.387a9.01 9.01 0 0 0-7.668-6.386zM1.37 8.439a5 5 0 1 1 7.668-6.387A9.01 9.01 0 0 0 1.37 8.438zM10 18a7 7 0 1 1 0-14a7 7 0 0 1 0 14m1-8V6a1 1 0 0 0-2 0v5a1 1 0 0 0 1 1h3a1 1 0 0 0 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default alarmClockF
